/* eslint-disable */
/* eslint-disable react/prop-types */
import React from 'react'

export default function SourcePlate({ settings }) {
    const sp = settings.sourcePlate

    let promoX = 1.5
    let promoY = 5

    if (settings.shape === 'twitter') {
        promoX = 1.35
        promoY = 10
    }
    if (settings.shape === 'snap') {
        promoX = 1.9
        promoY = 3.5
    }

    const siteTextProps = {
        x: settings.svgWidth * 0.025,
        y: settings.margin.bottom / 1.6,
        className: 'site-title',
        fill: sp.siteColor,
        style: {
            fontSize: sp.siteTitleFontSize,
            fontFamily: sp.siteTitleFontFamily,
        },
    }

    let siteText
    if (sp.siteHrefUrl) {
        siteText = (
            <a href={sp.siteHrefUrl}>
                <text {...siteTextProps}>{sp.siteTitle}</text>
            </a>
        )
    } else {
        siteText = <text {...siteTextProps}>{sp.siteTitle}</text>
    }

    const sourceTextProps = {
        x: settings.svgWidth / 1.025,
        y: settings.margin.bottom / 1.6,
        className: 'source-title',
        fill: sp.sourceColor,
        style: {
            fontSize: sp.sourceTitleFontSize,
            fontFamily: sp.sourceTitleFontFamily,
        },
    }

    let sourceText
    if (sp.sourceHrefUrl) {
        sourceText = (
            <a href={sp.sourceHrefUrl}>
                <text {...sourceTextProps}>{sp.sourceTitle}</text>
            </a>
        )
    } else {
        sourceText = <text {...sourceTextProps}>{sp.sourceTitle}</text>
    }

    return (
        <g
            id="sourcePlate"
            transform={`translate(0,${settings.height + settings.margin.top})`}
        >
            <rect
                width={settings.svgWidth}
                height={settings.margin.bottom}
                fill={
                    sp.background === 'none'
                        ? sp.backgroundColor
                        : `url('#${sp.background}')`
                }
                stroke={sp.strokeBackground || '#c2c2c2'}
            />
            {siteText}
            {sp.sourceTitle === 'promo' ? (
                <g id="logo" transform="translate(0,0)">
                    <a href="https://baseballsavant.mlb.com/illustrator">
                        <image
                            href="https://baseballsavant.mlb.com/sections/evp/images/logo.png"
                            x={settings.svgWidth / promoX}
                            y={settings.margin.bottom / promoY}
                            height={22}
                            opacity={1}
                        />
                    </a>
                </g>
            ) : (
                sourceText
            )}
        </g>
    )
}
